(function(){
  const FLAG='facet:clearNext';
  const LS_KEYS=['customFilterSelections','lastFacetState','facet:shouldClearOnReturn'];
  const KEEP=['q'];
  let prevHref=location.href, prevHandle=getHandle(location.pathname);
  function isColPath(p){return/\/collections(\/|$)/.test(p)}
  function getHandle(p){const m=p.match(/\/collections\/([^\/\?]+)/);return m?decodeURIComponent(m[1]):null}
  function hasFacet(u){const sp=new URL(u,location.origin).searchParams;for(const k of sp.keys()){if(k.startsWith('filter.')||k==='sort_by'||k==='page'||k==='filter.v.price.gte'||k==='filter.v.price.lte')return true}return false}
  function strip(u){const url=new URL(u,location.origin);const keep=new URLSearchParams;KEEP.forEach(k=>{if(url.searchParams.has(k))keep.set(k,url.searchParams.get(k))});url.search=keep.toString();return url.toString()}
  function clearLocal(){try{LS_KEYS.forEach(k=>localStorage.removeItem(k))}catch(_){}} 
  function mark(){sessionStorage.setItem(FLAG,'1')}
  function shouldMarkTransition(fromHref,toHref){
    const fromPath=new URL(fromHref,location.origin).pathname;
    const toPath=new URL(toHref,location.origin).pathname;
    const fromIsCol=isColPath(fromPath), toIsCol=isColPath(toPath);
    if(fromIsCol&&toIsCol){const a=getHandle(fromPath),b=getHandle(toPath);return a!==b}
    if(fromIsCol&&!toIsCol)return true
    if(!fromIsCol&&toIsCol)return true
    return false
  }
  function maybeClear(){
    const currHandle=getHandle(location.pathname);
    const flag=sessionStorage.getItem(FLAG)==='1';
    const changed=prevHandle&&currHandle&&prevHandle!==currHandle;
    if(isColPath(location.pathname)&&(flag||changed||hasFacet(location.href))){
      sessionStorage.removeItem(FLAG);
      clearLocal();
      const clean=strip(location.href);
      if(clean!==location.href){history.replaceState(null,'',clean)}
    }
    prevHref=location.href;prevHandle=currHandle
  }
  document.addEventListener('click',function(e){
    const a=e.target.closest('a[href]');
    if(!a)return;
    const href=a.getAttribute('href');if(!href||href.startsWith('#'))return;
    const dest=new URL(href,location.origin).toString();
    if(shouldMarkTransition(location.href,dest))mark()
  },true);
  const _ps=history.pushState,_rs=history.replaceState;
  history.pushState=function(){const r=_ps.apply(this,arguments);window.dispatchEvent(new Event('urlchange'));return r}
  history.replaceState=function(){const r=_rs.apply(this,arguments);window.dispatchEvent(new Event('urlchange'));return r}
  window.addEventListener('popstate',()=>window.dispatchEvent(new Event('urlchange')));
  window.addEventListener('urlchange',maybeClear);
  window.addEventListener('pageshow',maybeClear);
  if(document.readyState!=='loading')maybeClear();else document.addEventListener('DOMContentLoaded',maybeClear);
})();


(function() {
  const FACET_KEYS = ['filter.', 'sort_by', 'page', 'availability', 'price', 'variant'];
  const STORE_KEY = 'facet:shouldClearOnReturn';
  const LAST_COLLECTION_KEY = 'facet:lastCollectionHandle';
  const FILTER_STORAGE_KEY = 'customFilterSelections';

  function getCollectionHandleFromPath(pathname) {
    const m = pathname.match(/\/collections\/([^\/\?]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function hasFacetParams(url) {
    const p = new URL(url, location.origin).searchParams;
    if (Array.from(p.keys()).some(k => FACET_KEYS.some(f => k.startsWith(f)))) return true;
    if (p.has('filter.v.price.gte') || p.has('filter.v.price.lte')) return true;
    return false;
  }

  function stripFacetParams(u) {
    const url = new URL(u, location.origin);
    const p = url.searchParams;
    Array.from(p.keys()).forEach(k => {
      if (FACET_KEYS.some(f => k.startsWith(f))) p.delete(k);
      if (k === 'filter.v.price.gte' || k === 'filter.v.price.lte') p.delete(k);
    });
    url.search = p.toString();
    return url.toString();
  }

  function shouldClearOnLanding() {
    if (sessionStorage.getItem(STORE_KEY) === '1') return true;
    const currentHandle = getCollectionHandleFromPath(location.pathname) || '';
    const lastHandle = sessionStorage.getItem(LAST_COLLECTION_KEY) || '';
    if (currentHandle && lastHandle && currentHandle !== lastHandle) return true;
    return false;
  }

  function markLeavingCollectionsIfNeeded(e) {
    const a = e.target.closest('a');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href) return;

    const dest = new URL(href, location.origin);
    
    if (!/^\/collections\//.test(dest.pathname)) {
      sessionStorage.setItem(STORE_KEY, '1');
      return;
    }

    const destHandle = getCollectionHandleFromPath(dest.pathname) || '';
    const currentHandle = getCollectionHandleFromPath(location.pathname) || '';
    if (destHandle && currentHandle && destHandle !== currentHandle) {
      sessionStorage.setItem(STORE_KEY, '1');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const currentHandle = getCollectionHandleFromPath(location.pathname) || '';
    if (currentHandle) sessionStorage.setItem(LAST_COLLECTION_KEY, currentHandle);
  });

  document.addEventListener('click', markLeavingCollectionsIfNeeded);

  window.addEventListener('pageshow', () => {
    if (!/\/collections\//.test(location.pathname)) return;
    if (shouldClearOnLanding() && hasFacetParams(location.href)) {
      sessionStorage.removeItem(STORE_KEY);
      try { localStorage.removeItem(FILTER_STORAGE_KEY); } catch(_) {}
      const cleanUrl = stripFacetParams(location.href);
      if (cleanUrl !== location.href) {
        location.replace(cleanUrl);
      }
    }
  });

  window.addEventListener('beforeunload', () => {
    const currentHandle = getCollectionHandleFromPath(location.pathname) || '';
    if (currentHandle) sessionStorage.setItem(LAST_COLLECTION_KEY, currentHandle);
  });
})();



const FILTER_STORAGE_KEY = 'customFilterSelections';
let initializationInProgress = false;
let lastInitTime = 0;
let lastFilterStates = new Map();

function hideOriginalFiltersInstantly() {
    const originalContainers = document.querySelectorAll('.checkbox-list .checkbox-container:not(.custom-filter-container)');
    originalContainers.forEach(container => {
        if (!container.hasAttribute('data-original-filter')) {
            container.setAttribute('data-original-filter', 'true');
            container.style.display = 'none';
            container.style.visibility = 'hidden';
        }
    });
}

function createPlaceholder(checkboxList, filterName) {
    const existingPlaceholder = checkboxList.querySelector('.custom-filter-placeholder');
    if (existingPlaceholder) return existingPlaceholder;
    
    const placeholder = document.createElement('div');
    placeholder.className = 'custom-filter-placeholder';
    placeholder.innerHTML = `<div style="padding: 10px; color: #999; font-size: 14px;">Loading...</div>`;
    
    checkboxList.insertBefore(placeholder, checkboxList.firstChild);
    return placeholder;
}

function saveFilterState() {
    const filterState = {};
    document.querySelectorAll('.custom-filter-interface').forEach((customInterface, index) => {
        const accordion = customInterface.closest('details.accordion');
        const filterName = accordion?.querySelector('.accordion__toggle span')?.textContent || `filter_${index}`;
        
        filterState[filterName] = [];
        
        customInterface.querySelectorAll('.custom-filter-container .checkbox').forEach(checkbox => {
            if (checkbox.checked) {
                filterState[filterName].push(checkbox.value);
            }
        });
        
        lastFilterStates.set(filterName, customInterface.innerHTML);
    });
    
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filterState));
}

function loadFilterState() {
    try {
        const savedState = localStorage.getItem(FILTER_STORAGE_KEY);
        return savedState ? JSON.parse(savedState) : {};
    } catch (e) {
        return {};
    }
}

function initializeClearFiltersButton() {
    function clearAllFilters() {
        localStorage.removeItem(FILTER_STORAGE_KEY);
        lastFilterStates.clear();
        
        document.querySelectorAll('.custom-filter-checkbox').forEach(checkbox => {
            checkbox.checked = false;
        });
        
        document.querySelectorAll('.checkbox-container[data-original-filter="true"] .checkbox').forEach(checkbox => {
            if (checkbox.checked) {
                checkbox.checked = false;
                checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
        
        document.querySelectorAll('input[name="sort_by"]').forEach(radio => {
            if (radio.checked) {
                radio.checked = false;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
        
        document.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach(input => {
            if (input.value) {
                input.value = '';
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
        
        const baseUrl = window.location.pathname;
        const newUrl = new URL(baseUrl, window.location.origin);
        
        const currentParams = new URLSearchParams(window.location.search);
        const preserveParams = ['q'];
        
        preserveParams.forEach(param => {
            if (currentParams.has(param)) {
                newUrl.searchParams.set(param, currentParams.get(param));
            }
        });
        
        window.location.href = newUrl.toString();
    }
    
    function createClearButton(container) {
        if (container.closest('.collection__facets')) {
            return null;
        }
        
        let clearButton = container.querySelector('.clear-custom-filters');
        
        if (!clearButton) {
            clearButton = document.createElement('button');
            clearButton.className = 'clear-custom-filters';
            clearButton.textContent = 'Clear All Filters';
            clearButton.type = 'button';
            clearButton.setAttribute('aria-label', 'Clear all active filters');
            
            if (container.firstChild) {
                container.insertBefore(clearButton, container.firstChild);
            } else {
                container.appendChild(clearButton);
            }
        }
        
        return clearButton;
    }
    
    function initializeClearButtons() {
        const containers = [
            document.querySelector('#facet-form'),
            document.querySelector('.clear-filters-container'),
            document.querySelector('.facets-vertical')
        ].filter(Boolean);
        
        containers.forEach((container) => {
            createClearButton(container);
        });
    }
    
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('clear-custom-filters') && !e.target.classList.contains('sidebar-clear-btn')) {
            e.preventDefault();
            e.stopPropagation();
            clearAllFilters();
            return;
        }
    }, true);
    
    setTimeout(initializeClearButtons, 200);
}

function initializeCustomFilters() {
    const now = Date.now();
    
    if (initializationInProgress || (now - lastInitTime < 100)) {
        return;
    }
    
    initializationInProgress = true;
    lastInitTime = now;
    
    hideOriginalFiltersInstantly();
    
    const accordions = document.querySelectorAll('details.accordion');
    
    if (accordions.length === 0) {
        initializationInProgress = false;
        return;
    }
    
    const savedFilterState = loadFilterState();
    const urlParams = new URLSearchParams(window.location.search);
    const hasUrlFilters = Array.from(urlParams.keys()).some(key => key.startsWith('filter.'));
    
    if (!hasUrlFilters) {
        localStorage.removeItem(FILTER_STORAGE_KEY);
        lastFilterStates.clear();
    }
    
    accordions.forEach((accordion, accordionIndex) => {
        const filterName = accordion.querySelector('.accordion__toggle span')?.textContent || `filter_${accordionIndex}`;
        const checkboxList = accordion.querySelector('.checkbox-list');
        
        if (!checkboxList) return;
        
        let placeholder = null;
        
        const existingInterface = checkboxList.querySelector('.custom-filter-interface');
        if (existingInterface) {
            placeholder = createPlaceholder(checkboxList, filterName);
            existingInterface.remove();
        }
        
        const originalContainers = checkboxList.querySelectorAll('.checkbox-container:not(.custom-filter-container)');
        
        if (originalContainers.length === 0) {
            if (placeholder) placeholder.remove();
            return;
        }
        
        const originalByValue = new Map();
        const uniqueValues = new Set();
        
        originalContainers.forEach(container => {
            container.setAttribute('data-original-filter', 'true');
            container.style.display = 'none';
            container.style.visibility = 'hidden';
            
            const checkbox = container.querySelector('.checkbox');
            if (!checkbox) return;
            
            const value = checkbox.value.trim();
            
            if (value.includes(',')) {
                return;
            }
            
            originalByValue.set(value, checkbox);
            uniqueValues.add(value);
        });
        
        if (uniqueValues.size === 0) {
            if (placeholder) placeholder.remove();
            return;
        }
        
        const sortedValues = Array.from(uniqueValues).sort();
        const savedValues = hasUrlFilters ? [] : (savedFilterState[filterName] || []);
        
        const customInterface = document.createElement('div');
        customInterface.className = 'custom-filter-interface';
        customInterface.setAttribute('data-filter-name', filterName);
        
        sortedValues.forEach((value, index) => {
            const container = document.createElement('div');
            container.className = 'checkbox-container custom-filter-container';
            container.setAttribute('data-custom-filter-item', 'true');
            
            const checkbox = document.createElement('input');
            checkbox.id = `custom-${accordionIndex}-${index}-${now}`;
            checkbox.className = 'checkbox custom-filter-checkbox';
            checkbox.type = 'checkbox';
            checkbox.name = originalByValue.get(value).name;
            checkbox.value = value;
            
            const originalCheckbox = originalByValue.get(value);
            let shouldBeChecked = originalCheckbox.checked;
            
            if (!shouldBeChecked && savedValues.includes(value)) {
                shouldBeChecked = true;
            }
            
            checkbox.checked = shouldBeChecked;
            
            const label = document.createElement('label');
            label.htmlFor = checkbox.id;
            label.textContent = value;
            label.className = 'custom-filter-label';
            
            container.appendChild(checkbox);
            container.appendChild(label);
            customInterface.appendChild(container);
            
            checkbox.addEventListener('change', function(e) {
                const targetValue = e.target.value;
                const targetOriginal = originalByValue.get(targetValue);
                
                if (targetOriginal) {
                    targetOriginal.checked = e.target.checked;
                    targetOriginal.dispatchEvent(new Event('change', { bubbles: true }));
                }
                
                saveFilterState();
            });
        });
        
        if (placeholder) {
            checkboxList.replaceChild(customInterface, placeholder);
        } else {
            checkboxList.insertBefore(customInterface, checkboxList.firstChild);
        }
    });
    
    initializationInProgress = false;
}

const preventFlashObserver = new MutationObserver(function(mutations) {
    let needsInit = false;
    
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                    if (node.classList?.contains('checkbox-list') || 
                        node.classList?.contains('accordion') ||
                        node.querySelector?.('.checkbox-list')) {
                        needsInit = true;
                    }
                    
                    if (node.classList?.contains('checkbox-container') && 
                        !node.classList?.contains('custom-filter-container')) {
                        node.setAttribute('data-original-filter', 'true');
                        node.style.display = 'none';
                        node.style.visibility = 'hidden';
                    }
                }
            });
        }
    });
    
    if (needsInit) {
        hideOriginalFiltersInstantly();
        setTimeout(() => {
            initializeCustomFilters();
            initializeClearFiltersButton();
        }, 50);
    }
});

document.addEventListener('DOMContentLoaded', function() {
    preventFlashObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    const checkFilters = () => {
        const accordions = document.querySelectorAll('details.accordion');
        if (accordions.length > 0) {
            hideOriginalFiltersInstantly();
            initializeCustomFilters();
            initializeClearFiltersButton();
        } else {
            setTimeout(checkFilters, 25);
        }
    };
    
    checkFilters();
});

if (window.Shopify) {
    document.addEventListener('shopify:section:load', function() {
        hideOriginalFiltersInstantly();
        setTimeout(() => {
            initializeCustomFilters();
            initializeClearFiltersButton();
        }, 50);
    });
}

let originalFetch = window.fetch;
window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
        if (args[0] && (args[0].includes('filter') || args[0].includes('facet'))) {
            setTimeout(() => {
                hideOriginalFiltersInstantly();
                initializeCustomFilters();
                initializeClearFiltersButton();
            }, 30);
        }
        return response;
    });
};

const style = document.createElement('style');
style.textContent = `
    .checkbox-container[data-original-filter="true"] {
        display: none !important;
        visibility: hidden !important;
    }
    
    .custom-filter-container[data-custom-filter-item="true"] {
        display: flex !important;
        align-items: center;
        margin-bottom: 8px;
        padding: 4px 0;
    }
`;
document.head.appendChild(style);



window.clearAllCustomFilters = function() {
  const button = document.querySelector('.sidebar-clear-btn');
  if (button) {
    button.classList.add('loading');
    button.disabled = true;
    
    setTimeout(() => {
      try {
        localStorage.removeItem('customFilterSelections');
        if (typeof lastFilterStates !== 'undefined') {
          lastFilterStates.clear();
        }
      } catch(e) {}
      
      document.querySelectorAll('.custom-filter-checkbox').forEach(checkbox => {
        checkbox.checked = false;
      });
      
      document.querySelectorAll('.checkbox-container[data-original-filter="true"] .checkbox').forEach(checkbox => {
        if (checkbox.checked) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      
      document.querySelectorAll('input[name="sort_by"]').forEach(radio => {
        if (radio.checked) {
          radio.checked = false;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      
      document.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach(input => {
        if (input.value) {
          input.value = '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      
      const currentUrl = new URL(window.location);
      const baseUrl = currentUrl.pathname;
      const newUrl = new URL(baseUrl, window.location.origin);
      
      const currentParams = new URLSearchParams(window.location.search);
      const preserveParams = ['q'];
      
      preserveParams.forEach(param => {
        if (currentParams.has(param)) {
          newUrl.searchParams.set(param, currentParams.get(param));
        }
      });
      
      window.location.href = newUrl.toString();
    }, 300);
  }
};

window.clearAllFilters = window.clearAllCustomFilters;


